import { Space, Switch, SwitchProps } from "antd"
import { ReactNode } from "react"

export type Props = SwitchProps & {
  label: ReactNode
  onChange?: (value: boolean) => void
}

const LabeledSwitch = (props: Props) => {
  const { label, value, onChange, ...switchProps } = props
  const handleChange = (value: boolean) => {
    if (props.disabled) {
      return
    }
    return onChange?.(value)
  }

  return <Space
    onClick={() => handleChange(!value)}
    style={{ cursor: props.disabled ? 'not-allowed' : 'pointer' }}
  >
    <Switch {...switchProps} value={value} onChange={handleChange} />
    {label}
  </Space>
}

export default LabeledSwitch
